export default "__VITE_ASSET__BW6Y3U44__"